import { trackError } from '#api/errors.ts';
import { FilterPill } from '#components/atoms/pill/filter-pill/FilterPill.tsx';
import type { HOST_FILTERS } from '#hooks/useHostFilters.ts';
import { UnreachableCodeError } from '#util/assert-unreachable.ts';

type Props = {
  onClick: () => void;
  filterName: (typeof HOST_FILTERS)[number];
  label?: string;
};

export function HostFilterPill({ onClick, filterName, label }: Props) {
  return <FilterPill label={label ?? filterNameToLabel(filterName)} onClick={onClick} />;
}

function filterNameToLabel(filterName: (typeof HOST_FILTERS)[number]) {
  switch (filterName) {
    case 'type':
      return 'Type';
    case 'updateAvailable':
      return 'Update available';
    case 'isBlocked':
      return 'Blocked';
    case 'unenrolled':
      return 'Not enrolled';
    case 'mobile':
      return 'Mobile';
    case 'networkID':
      return 'Network';
    case 'roleID':
      return 'Role';
    case 'endpointOIDCUserID':
      return 'Device owner';
    case 'tags':
      return 'Tags';
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      trackError(new UnreachableCodeError(filterName, `Unknown filter name ${filterName} in FilterPill.tsx`));
      return filterName;
  }
}
